/**
 * AutomationIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const AutomationIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.315 9.796a2 2 0 1 1 2.827-2.829 2 2 0 0 1-2.827 2.83" />
    <path
      fillRule="evenodd"
      d="M20.933 2.469a1 1 0 0 1 .71.71 11.25 11.25 0 0 1-2.81 11.15 18.7 18.7 0 0 1-2.6 2.11 20.3 20.3 0 0 1-2.51 5.25 1 1 0 0 1-.74.42h-.08a1 1 0 0 1-.71-.29l-9.9-9.9a1 1 0 0 1-.29-.79 1 1 0 0 1 .42-.74 20.3 20.3 0 0 1 5.25-2.51 18.7 18.7 0 0 1 2.11-2.6 11.25 11.25 0 0 1 11.15-2.81m-10.51 14.78a22 22 0 0 0 7-4.34 9.09 9.09 0 0 0 2.43-8.67 9.09 9.09 0 0 0-8.65 2.43 22 22 0 0 0-4.34 7z"
      clipRule="evenodd"
    />
    <path d="M7.243 19.729a4 4 0 0 1-3.86 1 4 4 0 0 1 1.03-3.86z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const AutomationIcon = makeIcon('AutomationIcon', AutomationIconSvg)
